export type Locale = 'en' | 'da';

const da = {
  common: {
    from: 'Fra',
    before: 'Før',
    sso_price: 'Medlemspris:',
    regular_price: 'Normalpris:',
    ticket: 'Billet',
    ticket_plural: 'Billetter',
    edit: 'Rediger',
    pcs: 'stk.',
    discount: 'Rabat',
    transaction_fee: 'Transaktionsgebyr',
    back: 'Tilbage',
    back_to_overview: 'Tilbage til oversigt',
    continue: 'Fortsæt',
    fee: 'Billetgebyr',
    total: 'Total',
    vat: 'Moms udgør',
    decrease: 'Sænk',
    increase: 'Forøg',
    days: 'dage',
    show_more: 'Vis mere',
    show_less: 'Vis mindre',
    see_all: 'Se alle',
    see_category: 'Se kategori',
    close: 'Luk',
    cancel: 'Annuller',
    next: 'Næste',
    prev: 'Forrige',
    soldout: 'Udsolgt',
    waitlist: 'Venteliste',
    few_tickets: 'Få billetter tilbage',
    remove: 'Fjern',
    cart_emptied_toast:
      'Tiden til at placere din ordre er udløbet. Du har 10 minutter til at fuldføre en ordre.',
    loading: 'Indlæser...',
    send: 'Send',
  },
  checkout: {
    addons: 'Tilvalg',
    tickets: 'Billetter',
    information: 'Oplysninger',
    choose_tickets: 'Vælg billetter',
    choose_seats: 'Vælg pladser',
    redeem: 'Indløs',
    discount_code: 'Rabatkode',
    redeem_discount_code: 'Indløs rabatkode',
    vouchercode_removed: '{voucher_code_description} fjernet',
    redeem_gift_card: 'Indløs gavekort',
    gift_card: 'Gavekort',
    giftcard_added: 'Gavekort tilføjet',
    giftcard_not_found: 'Gavekort ikke fundet eller ugyldigt',
    type: 'Indtast',
    download_your_tickets: 'Hent dine billetter',
    loading_pdf: 'Vent venligst...',
    download_tickets: 'Hent billetter',
    download_tickets_as_pdf: 'Download billetter som PDF',
    your_tickets_are_also_sent_to: 'Dine billetter er også sendt til:',
    show_info: 'Vis info',
    ticket_info: 'Billetinfo',
    leave_checkout: 'Forlad checkout',
    leave_checkout_header: 'Du er ved at forlade checkout',
    leave_checkout_header_expired: 'Tiden er udløbet for checkout',
    leave_checkout_confirmation: 'Du vil miste dine billetter hvis du forlader checkout.',
    leave_checkout_confirmation_expired: 'Tiden til at placere din ordre er udløbet.',
    leave_checkout_continue: 'Du kan lægge dine billetter i kurv, og købe flere billetter.',
    leave_checkout_leaving_payment: 'Hvis du forlader checkout nu, vil din betaling blive afbrudt og du må genbestille.',
    basket_timeout_heading: 'Din kurv er udløbet',
    basket_timeout_description: 'Tiden til at gennemføre din bestilling er udløbet. Du kan starte forfra og vælge dine billetter igen.',
    basket_timeout_start_over: 'Start forfra',
    stay_in_checkout: 'Bliv i checkout',
    stay_in_checkout_cancel: 'Annuller',
    reservation_mismatch:
      'Antallet af billetter kan ikke opnåes. Kurven er opdateret med det antal billetter som er muligt.',
    reservation_mismatch_event_max_tickets:
      'Max {count} {tickets} kan bestilles for dette event.',
    reservation_mismatch_available:
      'Kun {count} {tickets} er tilgængelige for denne billettype.',
    reservation_mismatch_ticket_max_tickets:
      'Max {count} {tickets} kan bestilles for denne billettype.',
    reservation_mismatch_ticket_min_tickets:
      'Du skal bestille mindst {count} {tickets} for denne billettype.',
    leave: 'Forlad',
    payment: 'Betaling',
    choose_payment_method: 'Vælg betalingsmetode',
    countdown: 'tilbage til at udføre ordren',
    receipt: 'Kvittering',
    organizer: 'Arrangør',
    order_information: 'Ordre information',
    order_number: 'Ordrenummer',
    order_time: 'Tidspunkt for køb',
    transaction_id: 'Transaktions ID',
    card_number: 'Kortnummer',
    add_to_calendar: 'Tilføj til kalender',
    download_ics: 'Download ICS',
    order_summary: 'Ordreopsummering',
    continue_to_payment: 'Fortsæt til betaling',
    continue_to_payment_window: 'Fortsæt til betalingsvinduet',
    continue_ordering: 'Fortsæt billetbestilling',
    cancel_order: 'Annuller ordre',
    add_to_basket_and_continue: 'Læg i kurv og shop mere',
    add_info_to: 'Tilføj info til {name}',
    order_confirmation_will_be_sent_to:
      'Din ordrebekræftelse bliver sendt hertil',
    email_placeholder: 'E-mail',
    repeat_email_placeholder: 'Gentag e-mail',
    name_placeholder: 'For- og efternavn',
    address_placeholder: 'Adresse',
    zip_placeholder: 'Post nr.',
    city_placeholder: 'By',
    country_placeholder: 'Land',
    phone_placeholder: 'Telefonnummer',
    terms_label: 'Jeg accepterer salgs- og leveringsbetingelser',
    terms_label_prefix: 'Jeg accepterer ',
    terms_label_link: 'salgs- og leveringsbetingelser',
    terms_label_header: 'Salgs- og leveringsbetingelser',
    extra_terms_label_prefix: 'Jeg accepterer også ',
    newsletter_label: 'Ja tak, tilmeld mig {organizer} nyhedsbrev',
    seats: 'Pladser',
    see_seats: 'Se dine pladser ({selected} / {total} valgte)',
    edit_seat: 'Rediger plads',
    your_seats: 'Dine pladser',
    no_seats_selected: 'Ingen pladser valgt endnu',
    seatmap_progress: 'Pladsvalg {current} / {total}',
    next_seatmap: 'Næste salsplan',
    reset_seats: 'Fjern alt',
    reset_seats_long: 'Nulstil pladsvalg',
    change_number_of_seats: 'Ændre antal pladser',
    seatmap_help_title: 'Hjælp',
    seatmap_prices_title: 'Priser',
    seatmap_help_body_intro: 'Vælg dine ønskede pladser på oversigten.',
    seatmap_help_body_colors_title: 'Forskellige farver',
    seatmap_help_body_colors_content:
      'Hvis der er forskellige sædefarver eller områder, viser farverne, at pladserne har forskellige priser. Desuden kan farven vise at et sæde er reserveret.',
    seat_reservation_failed:
      'En eller flere pladser er desværre ikke længere tilgængelige.',
    seat_price_group_validation_failed:
      'Der opstod en fejl ved validering af pladsen. Prøv igen.',
    seat_invalid_placement:
      'Dit pladsvalg ville efterlade en enkelt ledig plads. Vælg en anden placering.',
    seat_invalid_placement_select_from_row:
      'Pladsvalg er ikke gyldigt. Du skal vælge pladser fra enden af en række. Vælg en anden placering.',
    seat_taken: 'Pladser markeret med rød er optaget.',
    seat_selection_required: 'Du mangler at vælge pladser for {event}.',
    event_seatmap_progress: 'Arrangement {current} af {total}',
    next_event_seats: 'Vælg pladser til {event}',
    switching_to_event: 'Vælg nu pladser til: {event}',
    seats_remaining_one: 'Du mangler at vælge 1 billet',
    seats_remaining: 'Du mangler at vælge {count} billetter',
    extra_tickets_shown: 'Der vises nu {count} billetter med koden:',
    extra_ticket_shown: 'Der vises nu 1 billet med koden:',
    tickets_recievement_notice:
      'Du modtager din billet pr. e-mail og skal medbringe den digitalt eller selv printe den ud.',
    thanks_for_your_order: 'Tak for din bestilling',
    ticket_buying_title: 'Billetkøb info',
    ticket_buying_notice:
      'Dine billetter er betalt. Du kan hente dem her på siden.',
    tickets_sent_to_email:
      'Vi har samtidig fremsendt dine billetter til din e-mailadresse: {email}',
    tickets_entry_notice:
      'Arrangøren kan bede dig om at fremvise din billet ved indgangen. Kontrollér derfor venligst billetten for arrangement, dato, tidspunkt m.v. Det er vigtigt, at din billet er i hel og læselig tilstand, når du ankommer til arrangementet. En billet og den unikke stregkode giver adgang for én person. Det er ulovligt at kopiere billetter.',
    tickets_bank_statement:
      'Billetkøbet vil fremgå som et køb hos Safeticket på dit kontoudtog.',
    tickets_law_notice:
      'Bemærk: I henhold til "Lov om forbrugeraftaler § 18 stk. 12" er køb af billetter ikke omfattet af fortrydelsesretten.',
    tickets_see_terms: 'Se også ',
    tickets_see_terms_link: 'salgs- og leveringsbetingelserne.',
    questions: 'Har du spørgsmål?',
    questions_can_be_sent_to:
      'Spørgsmål kan rettes til <a href="mailto:{email}"> {email}</a> eller <a href="tel:{phone}">{phone}</a>.',
    questions_order_number:
      'Oplys venligst ordrenummer ved eventuelt henvendelse til Safeticket A/S.',
    customfield_group_header_event: '',
    customfield_group_header_tickettype: 'Generelt for tilmelding',
    customfield_group_header_ticket: '{group} Tilmelding',
    invoice_payment: 'Faktura betaling',
    card_payment: 'Kortbetaling',
    ivp_name_placeholder: 'Firma / Institution',
    ivp_attperson_placeholder: 'Att. person',
    ivp_address_placeholder: 'Adresse',
    ivp_zip_placeholder: 'Post nr.',
    ivp_city_placeholder: 'By',
    ivp_email_placeholder: 'E-mail',
    ivp_repeat_email_placeholder: 'Gentag e-mail',
    ivp_ean_placeholder: 'EAN nummer',
    ivp_cvr_placeholder: 'CVR nummer',
    ivp_reference_placeholder: 'Reference',
    ivp_terms_label:
      'Jeg accepterer at billetterne ikke kan refunderes, og at jeg modtager en faktura efterfølgende.',
    ivp_submit: 'Gå til betaling',
    limit_order_by_userdefined_id_buy_limit:
      'Din reservation er blevet justeret til det højest tilladte for denne billet.',
    limit_order_by_userdefined_id_invalid:
      'Det angivne kunde ID er ikke gyldigt. Hvis dette fortsætter kontakt arrangøren.',
    limit_order_by_userdefined_id_no_response:
      'Reservation kunne ikke gennemføres pga. mangel på respons fra arrangøren.',
    event_state: {
      loading: 'Henter billetsalget...',
      not_started: {
        title: 'Billetsalget er ikke startet endnu',
        description: 'Billetsalget til dette arrangement åbner senere.',
        description_with_date: 'Billetsalget åbner {date}.',
      },
      ended: {
        title: 'Billetsalget er slut',
        description: 'Det er ikke længere muligt at købe billetter til dette arrangement.',
      },
      sold_out: {
        title: 'Arrangementet er udsolgt',
        description: 'Der er ikke flere billetter tilgængelige til dette arrangement.',
      },
      not_found: {
        title: 'Arrangementet blev ikke fundet',
        description: 'Linket er muligvis forkert, eller arrangementet er ikke længere tilgængeligt.',
      },
      error: {
        title: 'Noget gik galt',
        description: 'Billetsalget kunne ikke indlæses. Luk vinduet, og prøv igen.',
      },
    },
    sale_is_over: 'Salget for dette arrangement er slut.',
  },
  event: {
    events: 'Arrangementer',
    play_video: 'Afspil video',
    go_to_slide: 'Gå til slide {slide}',
    open_in_google_maps: 'Åbn i Google Maps',
    location: 'Lokation',
    find_tickets: 'Find billetter',
    login_to_find_tickets: 'Log ind for at se billetter',
    sso_no_access: 'Du skal være abonnent for at købe billetter',
    x_tickets_left: '{count} billetter tilbage',
    time: 'Tidspunkt',
    related_events: 'Relaterede arrangementer',
    categories: 'Kategorier',
    organizer: 'Arrangør',
    organizer_name: 'Arrangør navn',
    remarks: 'Bemærkning',
    photo_video_social_media: 'Foto, video og sociale medier',
    photo_video: 'Foto og Video',
    photo_video_notice:
      'Ut ultricies vestibulum lacus in semper consectetur. Donec non tellus ut enim aliquet lacinia. Aenean ac orci id elit molestudas rhoncus porttitor eget lacus. Quisque a justo tristique, congue dolor et, scelerisque velit. Mauris eget dictum pulvinar. Sed bibendum ut magna ut tincidunt. Praesent pretium ut mi elementum. Phasellus condimentum leo quis erat rhoncus, et lacinia mi dictum.',
    social_media: 'Sociale medier',
    social_media_notice:
      'Ut ultricies vestibulum lacus in semper consectetur. Donec non tellus ut enim aliquet lacinia. Aenean ac orci id elit molestudas rhoncus porttitor eget lacus. Quisque a justo tristique, congue dolor et, scelerisque velit. Mauris eget dictum pulvinar. Sed bibendum ut magna ut tincidunt. Praesent pretium ut mi elementum. Phasellus condimentum leo quis erat rhoncus, et lacinia mi dictum.',
    ends_in: 'Slutter om',
    ends_at: 'Slutter',
    starts_in: 'Starter om',
    sold_out: 'Udsolgt',
    subscribe_to_waitlist: 'Tilmeld venteliste',
    waitlist_modal_title: 'Venteliste',
    waitlist_description:
      'Skriv dig på venteliste, hvis du vil have besked, når der kommer flere billetter i salg.',
    waitlist_success: 'Du er nu tilmeldt ventelisten',
    waitlist_error_invalid_email: 'E-mail',
    waitlist_error_generic: 'Der opstod en fejl. Prøv venligst igen.',
    sale_not_started: 'Billetsalg ikke startet endnu',
    sale_not_started_with_date: 'Billetsalg starter {date}',
    sale_ended: 'Billetsalg slut',
    doorsale_button: 'Sælges i døren',
    visit_external_shop: 'Besøg webshop',
  },
  validation: {
    number: 'Dette felt skal være et tal',
    email: 'Indtast venligst en gyldig e-mailadresse',
    emails_must_match: 'E-mailadresserne skal matche',
    phone: 'Indtast venligst et gyldigt telefonnummer',
    cpr: 'Indtast venligst et gyldigt CPR-nummer',
    required: 'Dette felt er påkrævet',
    zip: 'Indtast venligst et gyldigt postnummer',
    terms: 'Du skal acceptere salgs- og leveringsbetingelserne',
    terms_generic: 'Du skal acceptere betingelserne',
    order_number: 'Indtast venligst et gyldigt ordrenummer',
    char_limit: 'Maksimalt {limit} tegn tilladt',
    exact_length: 'Dette felt skal være præcis {length} tegn',
    invalid_option: 'Indtast venligst en gyldig værdi',
  },
  order_errors: {
    missingemail: 'Indtast venligst din e-mailadresse',
    invalidemail: 'Den indtastede e-mailadresse er ugyldig',
    missingname: 'Indtast venligst dit navn',
    missingaddress: 'Indtast venligst din adresse',
    missingzip: 'Indtast venligst dit postnummer',
    missingcity: 'Indtast venligst din by',
    missingtelephone: 'Indtast venligst dit telefonnummer',
    missingcountry: 'Vælg venligst et land',
    unknown: 'Der opstod en fejl. Prøv venligst igen.',
    invalid_custom_fields:
      'Et eller flere felter indeholder ugyldige værdier. Ret venligst de markerede felter.',
  },
  globals: {
    change_language: 'Skift sprog',
    categories: 'Kategorier',
    locations: 'Lokationer',
    date: 'Dato',
    search: 'Søg',
    search_placeholder: 'Søg efter event...',
    cart: 'Kurv',
    continue_to_checkout: 'Fortsæt til bestilling',
    login: 'Login',
    sso_login: 'Log ind',
    sso_logout: 'Log ud',
    sso_welcome: 'Velkommen',
    cart_empty: 'Din kurv er tom',
    check_gift_card: 'Tjek gavekort',
    cancel_tickets: 'Annuller billetter',
    transfer_voucher: 'Overfør klip',
    organizer_login: 'Arrangør login',
    ticketing_system: 'Billetsystem',
    registration_system: 'Tilmeldingssystem',
    ticket_buyer: 'Billetkøber',
    resend_tickets: 'Mistet din billet?',
    contact: 'Kontakt',
    terms: 'Betingelser',
    cookies: 'Cookies',
    cta_title: 'Afholder du events? Få et billet- og tilmeldingssystem',
    cta_unique_selling_point_low_fee: 'Blandt Danmarks billigste',
    cta_unique_selling_point_support: 'Fri dansk support',
    cta_button_text: 'Se mere',
    choose: 'Vælg',
    no_results: 'Intet resultat. Prøv igen.',
    see_all_events: 'Se alle events',
    special_categories: 'Specielle kategorier',
    cookie_warning_dismiss: 'OK - Luk',
    cookie_warning_read_more: 'Læs mere',
    cookie_warning_header: 'Cookies',
    consent_accept_all: 'Acceptér alle',
    consent_reject_all: 'Afvis alle',
    consent_customize: 'Tilpas',
    consent_save_preferences: 'Gem valg',
    consent_necessary_title: 'Nødvendige',
    consent_necessary_description:
      'Disse cookies er nødvendige for at siden fungerer korrekt.',
    consent_statistics_title: 'Statistik',
    consent_statistics_description:
      'Hjælper os med at forstå hvordan besøgende bruger siden.',
    consent_marketing_title: 'Marketing',
    consent_marketing_description:
      'Bruges til at vise relevante annoncer på andre platforme.',
    consent_footer_link: 'Cookie-indstillinger',
  },
  date: {
    january: 'Januar',
    february: 'Februar',
    march: 'Marts',
    april: 'April',
    may: 'Maj',
    june: 'Juni',
    july: 'Juli',
    august: 'August',
    september: 'September',
    october: 'Oktober',
    november: 'November',
    december: 'December',
    mon: 'Man',
    tue: 'Tir',
    wed: 'Ons',
    thu: 'Tor',
    fri: 'Fre',
    sat: 'Lør',
    sun: 'Søn',
  },
  not_found: {
    title: 'Siden ikke fundet',
    message: 'Beklager, den side du leder efter findes ikke.',
    back_to_home: 'Tilbage til forsiden',
  },
  terms: {
    head_title: 'Betingelser',
    organizer: 'Arrangøren',
    sales_delivery_terms: 'Salgs og leveringsbetingelser',
    contact_person: 'Kontaktperson',
    phone: 'Telefon',
    email: 'E-mail',
    vat: 'CVR',
    applicable_for: 'Følgende betingelser er gældende for',
    hereafter_referred: 'Herefter benævnt',
    general: 'GENERELT',
    general_clause_1:
      'Enhver leverance mellem parterne finder sted på grundlag af nærværende almindelige salgs- og leveringsbetingelser.',
    general_clause_2:
      'formidler udelukkende salg af billetter mellem billetkøberen og den ansvarlige arrangør.',
    payment: 'BETALING',
    payment_clause_1:
      'Der kan betales med Dankort, Visa/Dankort, Visa, MasterCard samt VisaElectron.',
    payment_clause_2: 'Betaling skal finde sted ved onlinebetaling.',
    payment_clause_3:
      'Din betaling hæves fra dit betalingskort når billetten er afsendt.',
    delivery: 'LEVERING OG FORSINKELSE',
    delivery_clause_1:
      'Levering sker enten via direkte download samt elektronisk post i form af en PDF-fil (PrintSelv) straks efter betaling, eller ved valg af postforsendelse, fremsendt med PostDanmark som almindelig brevpost næste hverdag. Pengene hæves på dit betalingskort når billetten afsendes.',
    delivery_clause_2:
      'I tilfælde af bortkomst kan erstatningsbilletter fremsendes, hvorved de oprindelige billetter automatisk annulleres.',
    privacy: 'BEHANDLING AF PERSONOPLYSNINGER',
    privacy_clause_1:
      'Du accepterer som kunde at {name} opbevarer de af dig afgivne personoplysninger i forbindelse med billetkøb.',
    privacy_clause_2:
      '{name} overdrager informationer såsom navn, adresse, telefonnummer og e-mail til den arrangør, der afholder det pågældende arrangement du som kunde har købt billet til.',
    privacy_clause_3:
      'Dette sker med henblik på, at arrangøren kan yde den optimale kundeservice, f.eks. i tilfælde af aflysninger.',
    privacy_clause_4:
      '{name} videregiver ikke oplysningerne til andre end arrangøren af det pågældende arrangement.',
    liability: 'ANSVARSBEGRÆNSNING',
    liability_clause_1:
      'Kontroller venligst bestillingen inden betaling for at sikre dig i mod fejlbestillinger.',
    liability_clause_2:
      'Billetten erstattes ikke ved bortkomst, men kan genfremsendes elektronisk eller pr brevpost.',
    liability_clause_3:
      'Billetten kan KUN refunderes af arrangøren og KUN i tilfælde af aflysning.',
    liability_clause_4: 'Bestillings og leveringsgebyrer refunderes ikke.',
    liability_clause_5:
      '{name} har intet ansvar vedrørende arrangørens eventuelle betalingstandsning, konkurs, aflysning eller flytning af dato for afholdelse af et arrangement eller andre reklamationer vedrørende det aktuelle arrangement.',
    liability_clause_6:
      'Al henvendelse herom rettes til arrangøren. Kontaktoplysninger forefindes på billetten samt på hjemmesiden, hvor billetten er bestilt.',
    liability_clause_7:
      'Moms udgør 20% af billetsummen inklusive billetgebyr, såfremt der er pålagt moms på arrangementet.',
    refund: 'FORTRYDELSESRET',
    refund_clause_1:
      "{name} fungerer udelukkende som formidler af salg af billetter mellem kunden og den arrangør, der sælger billetterne via {name}'s onlinesystemer.",
    refund_clause_2:
      'Bemærk: I henhold til \"Lov om forbrugeraftaler § 18 stk. 12\" er køb af billetter ikke omfattet fortrydelsesretten.',
    changes: 'AFTALEÆNDRINGER',
    changes_clause_1:
      '{name} har ret til, på et hvilken som helst tidspunkt, at foretage ændringer i gældende forretningsbetingelser eller priser med 30 dages varsel.',
    law: 'LOVVALG OG VÆRNETING',
    law_clause_1:
      'Aftalen er underkastet dansk ret. Enhver uoverensstemmelse mellem parterne afgøres ved Retten i Aarhus.',
  },
  contact: {
    head_title: 'Kontakt',
    title: 'Kontakt os',
    info: 'Info',
    description:
      'Hvis du har spørgsmål til arrangementer listet på disse sider under {url} kan du henvende dig til arrangørens kontaktperson på nedenstående telefonnummer eller e-mailadresse.',
    organizer: 'Arrangør',
    contact_person: 'Kontaktperson',
    phone: 'Telefon',
    email: 'E-mail',
    email_placeholder: 'E-mail',
    name_placeholder: 'For- og efternavn',
    phone_placeholder: 'Telefonnummer',
    order_number_placeholder: 'Ordrenummer',
    body_placeholder: 'Besked',
    contact_form_info:
      'Du kan også kontakte arrangøren via nedenstående kontaktformular.',
    contact_form: 'Kontakt formular',
    submit: 'Send',
    success_message: 'Din besked er sendt!',
    error_message:
      'Der opstod en fejl ved afsendelse af din besked. Prøv venligst igen senere.',
  },
  doorsale: {
    select_events: 'Vælg events',
    search_placeholder: 'Søg...',
    loading: 'Henter arrangementer...',
    loading_receipt: 'Henter kvittering...',
    fetch_error: 'Der opstod en fejl ved hentning af arrangementer.',
    no_results: 'Ingen resultater',
    reset_filters: 'Nulstil filter',
    no_events: 'Ingen events tilgængelige',
    selected_events_one: 'valgt event',
    selected_events_other: 'valgte events',
    show_list: 'Vis',
    hide_list: 'Skjul',
    remove_all: 'Fjern alle',
    remove_event: 'Fjern',
    remove_event_cart_title: 'Fjerner du ét event, nulstilles hele kurven.',
    remove_event_cart_confirm: 'Ok, nulstil kurven',
    remove_event_cart_cancel: 'Luk - behold min kurv',
    no_events_selected: 'Ingen events valgt',
    continue: 'Fortsæt',
    confirm_payment: 'Bekræft betaling',
    placing_order: 'Gennemfører...',
    progress_bar: 'Event {n} ud af {total}',
    header_step_tickets: 'Billetter',
    header_step_customer_info: 'Kundeinfo',
    header_step_receipt: 'Kvittering',
    receipt_title: 'Salg gennemført',
    receipt_order_details: 'Ordredetaljer',
    mark_arrived: 'Markér ankommet',
    mark_arrived_loading: 'Markerer...',
    mark_arrived_success: 'Ankommet',
    mark_arrived_error: 'Fejl – prøv igen',
    print_tickets: 'Udskriv billetter',
    new_sale: 'Opret nyt salg',
    mark_arrived_question: 'Er gæsten/gæsterne ankommet?',
    mark_arrived_yes: 'Ja',
    mark_arrived_no: 'Nej',
    fetch_tickets: 'Hent billetter',
    print_receipt: 'Print kvittering',
    order_email: 'Deltager mail',
    print_buyer: 'Køber',
    print_items: 'Billetter',
    print_financial_summary: 'Betalingsoversigt',
    print_subtotal: 'Subtotal',
    print_card_fee: 'Kortgebyr',
    print_dankort_discount: 'Dankort rabat',
    order_confirmation_will_be_sent_to: 'Ordrebekræftelsen bliver sendt hertil',
    banner_mode: 'Du er i "udsted billetter"',
    banner_close: 'Afslut',
  },
  selfscan: {
    head_title: 'Billetaktivering',
    title: 'Aktivér dine billetter',
    description: 'Vælg den billet, du vil aktivere ved ankomst til arrangementet.',
    loading: 'Henter billetter...',
    invalid_link_title: 'Linket er ugyldigt',
    invalid_link_description: 'Kontrollér, at du har åbnet hele linket fra din billetmail.',
    not_found_title: 'Billetterne blev ikke fundet',
    not_found_description: 'Linket kan være forkert, eller billetaktivering er ikke tilgængelig for ordren.',
    no_tickets: 'Der er ingen billetter, som kan aktiveres på denne ordre.',
    opens_at: 'Kan aktiveres fra {date}',
    event: 'Arrangement',
    event_time: 'Tidspunkt',
    ticket_type: 'Billettype',
    ticket_number: 'Billetnummer',
    activation_time: 'Aktiveret',
    status: 'Status',
    activate: 'Aktivér',
    activated: 'Aktiveret',
    activated_at: 'Aktiveret {date}',
    confirm_eyebrow: 'Billetaktivering',
    confirm_title: 'Aktivering af billet',
    confirm_description: 'Kontrollér, at du er klar til at bruge billetten.',
    warning_title: 'Vigtigt før du aktiverer',
    warning_description: 'Aktivér først ved fremvisning',
    swipe_instruction: 'Swipe for at aktivere',
    swipe_accessible_label: 'Swipe til højre for at aktivere billetten',
    swipe_progress: '{progress} procent aktiveret',
    swipe_keyboard_instruction: 'Brug Enter eller mellemrum for at aktivere med tastaturet.',
    activating: 'Aktiverer...',
    activation_error: 'Billetten kunne ikke aktiveres. Prøv igen.',
    success_title: 'Allerede aktiveret',
    countdown_description: 'Billetoplysningerne vises automatisk om',
    countdown_seconds: '{count} sekunder tilbage',
    ticket_info_title: 'Oplysninger om billetten',
    ticket_info_description: 'Denne billet er allerede aktiveret.',
    back_to_tickets: 'Tilbage til billetter',
  },
  resend_ticket: {
    head_title: 'Gensend billetter',
    title: 'Gensend dine billetter',
    description:
      'Har du ikke modtaget dine billetter? Indtast din e-mailadresse herunder, så sender vi dem igen.',
    email_placeholder: 'E-mail',
    submit: 'Send billetter igen',
    success_message: 'Dine billetter er sendt til din e-mailadresse.',
    error_too_soon:
      'Du har allerede anmodet om at få dine billetter gensendt for nylig. Vent venligst lidt, og prøv igen.',
    error_invalid_email:
      'Vi kunne ikke finde nogen bestillinger tilknyttet denne e-mailadresse.',
    error_generic: 'Der opstod en fejl. Prøv venligst igen senere.',
  },
  toggle: {
    yes: 'Ja',
    no: 'Nej',
  },
  cancel_order: {
    head_title: 'Annuller billetter',
    title: 'Annuller billetter',
    description:
      'Indtast din e-mail og et ordrenummer for at annullere dine billetter. Du vil modtage en e-mail hvor du skal bekræfte annulleringen.',
    email_placeholder: 'E-mail',
    order_id_placeholder: 'Ordrenummer',
    submit: 'Send',
    success_message:
      'Vi har sendt en bekræftelsesmail til din e-mailadresse. Følg linket i mailen for at gennemføre annulleringen.',
    error_order_not_found:
      'Vi kunne ikke finde en bestilling med det angivne ordrenummer og e-mailadresse.',
    error_invalid_email: 'Den indtastede e-mailadresse er ugyldig.',
    error_invalid_order_id: 'Ordrenummeret skal være et gyldigt tal.',
    error_price_above_zero:
      'Denne bestilling kan ikke annulleres online, da den har en pris over 0 kr. Kontakt venligst arrangøren.',
    error_already_cancelled: 'Denne bestilling er allerede annulleret.',
    error_already_refunded: 'Denne bestilling er allerede refunderet.',
    error_generic: 'Der opstod en fejl. Prøv venligst igen senere.',
  },
  check_giftcard: {
    head_title: 'Tjek gavekort',
    title: 'Tjek gavekort',
    description:
      'Indtast din gavekortkode herunder for at se saldo og transaktionshistorik.',
    code_placeholder: 'Gavekortkode',
    submit: 'Tjek saldo',
    error_not_found:
      'Gavekortet blev ikke fundet. Kontroller venligst koden og prøv igen.',
    error_generic: 'Der opstod en fejl. Prøv venligst igen senere.',
    result_code: 'Kode',
    result_issue_date: 'Udstedt',
    result_expire_date: 'Udløber',
    result_balance: 'Saldo',
    transaction_header_date: 'Dato',
    transaction_header_type: 'Handling',
    transaction_header_amount: 'Beløb',
    transaction_type_deposit: 'Indsat',
    transaction_type_withdraw: 'Hævet',
  },
  meta: {
    frontpage_title: "Se kommende events {'|'} {alias}",
    frontpage_description: 'Se alle kommende events hos {alias}',
  },
};

const en: typeof da = {
  common: {
    from: 'From',
    before: 'Before',
    sso_price: 'Member price:',
    regular_price: 'Regular price:',
    ticket: 'Ticket',
    ticket_plural: 'Tickets',
    edit: 'Edit',
    pcs: 'pcs.',
    discount: 'Discount',
    transaction_fee: 'Transaction fee',
    back: 'Back',
    back_to_overview: 'Back to overview',
    continue: 'Continue',
    fee: 'Ticket fee',
    total: 'Total',
    vat: 'VAT',
    decrease: 'Decrease',
    increase: 'Increase',
    days: 'days',
    show_more: 'Show more',
    show_less: 'Show less',
    see_all: 'See all',
    see_category: 'See category',
    close: 'Close',
    cancel: 'Cancel',
    next: 'Next',
    prev: 'Previous',
    soldout: 'Soldout',
    waitlist: 'Waitlist',
    few_tickets: 'Few tickets left',
    remove: 'Remove',
    cart_emptied_toast:
      'The time to complete your order has run out. You have 10 minutes to complete a purchase.',
    loading: 'Loading...',
    send: 'Send',
  },
  checkout: {
    addons: 'Add-ons',
    tickets: 'Tickets',
    choose_seats: 'Choose seats',
    information: 'Customer information',
    choose_tickets: 'Choose tickets',
    redeem: 'Redeem',
    discount_code: 'Discount code',
    redeem_discount_code: 'Redeem discount code',
    redeem_gift_card: 'Redeem gift card',
    vouchercode_removed: '{voucher_code_description} removed',
    gift_card: 'Gift card',
    giftcard_added: 'Gift card added',
    giftcard_not_found: 'Gift card not found or invalid',
    type: 'Type',
    download_your_tickets: 'Download your tickets',
    loading_pdf: 'Please wait...',
    download_tickets: 'Download tickets',
    download_tickets_as_pdf: 'Download tickets as PDF',
    your_tickets_are_also_sent_to: 'Your tickets are also sent to:',
    show_info: 'Show info',
    ticket_info: 'Ticket info',
    leave_checkout: 'Leave checkout',
    leave_checkout_header: 'You are about to leave checkout',
    leave_checkout_header_expired: 'The time for checkout has expired',
    leave_checkout_confirmation:
      'You will lose your tickets if you leave checkout',
    leave_checkout_confirmation_expired:
      'The time to place your order has expired.',
    leave_checkout_continue:
      'You can add tickets to cart and buy more tickets.',
    leave_checkout_leaving_payment: 'If you leave checkout now, your payment will be cancelled and you will have to reorder.',
    basket_timeout_heading: 'Your basket has expired',
    basket_timeout_description: 'The time to complete your order has expired. You can start over and select your tickets again.',
    basket_timeout_start_over: 'Start over',
    stay_in_checkout: 'Stay in checkout',
    stay_in_checkout_cancel: 'Cancel',
    reservation_mismatch:
      'The number of tickets could not be reserved. The cart has been updated with the number of tickets that could be reserved.',
    reservation_mismatch_event_max_tickets:
      'Maximum {count} {tickets} can be reserved for this event.',
    reservation_mismatch_available:
      'Only {count} {tickets} are available for this ticket type.',
    reservation_mismatch_ticket_max_tickets:
      'You can only reserve a maximum of {count} {tickets} for this ticket type.',
    reservation_mismatch_ticket_min_tickets:
      'You must reserve at least {count} {tickets} for this ticket type.',
    leave: 'Leave',
    payment: 'Payment',
    choose_payment_method: 'Choose payment method',
    countdown: 'left to complete the order',
    receipt: 'Receipt',
    organizer: 'Organizer',
    order_information: 'Order information',
    order_number: 'Order number',
    order_time: 'Order time',
    transaction_id: 'Transaction ID',
    card_number: 'Card number',
    add_to_calendar: 'Add to calendar',
    download_ics: 'Download ICS',
    order_summary: 'Order summary',
    continue_to_payment: 'Continue to payment',
    continue_to_payment_window: 'Continue to payment window',
    continue_ordering: 'Continue ordering',
    cancel_order: 'Cancel order',
    add_to_basket_and_continue: 'Add to cart and shop more',
    add_info_to: 'Add info to {name}',
    order_confirmation_will_be_sent_to:
      'Your order confirmation will be sent here',
    email_placeholder: 'E-mail',
    repeat_email_placeholder: 'Repeat email',
    name_placeholder: 'First and last name',
    address_placeholder: 'Address',
    zip_placeholder: 'Postal code',
    city_placeholder: 'City',
    country_placeholder: 'Country',
    phone_placeholder: 'Phone number',
    terms_label: 'I accept the terms and conditions',
    terms_label_prefix: 'I accept the ',
    terms_label_link: 'terms and conditions',
    terms_label_header: 'Terms and Conditions',
    extra_terms_label_prefix: 'I also accept ',
    newsletter_label: 'Yes, sign me up for the {organizer} newsletter',
    seats: 'Seats',
    see_seats: 'See your seats ({selected} / {total} selected)',
    edit_seat: 'Edit seat',
    your_seats: 'Your seats',
    no_seats_selected: 'No seats selected yet',
    seatmap_progress: 'Seat selection {current} / {total}',
    next_seatmap: 'Next seating plan',
    reset_seats: 'Remove all',
    reset_seats_long: 'Reset selection',
    change_number_of_seats: 'Change number of seats',
    seatmap_help_title: 'Help',
    seatmap_prices_title: 'Prices',
    seatmap_help_body_intro: 'Select your desired seats on the overview.',
    seatmap_help_body_colors_title: 'Different colors',
    seatmap_help_body_colors_content:
      'If there are different seat colors or areas, the colors indicate that the seats have different prices. Additionally, the color may indicate that a seat is reserved.',
    seat_reservation_failed: 'One or more seats are no longer available.',
    seat_price_group_validation_failed:
      'An error occurred validating the seat. Please try again.',
    seat_invalid_placement:
      'Your selection would leave a single empty seat. Please choose a different placement.',
    seat_invalid_placement_select_from_row:
      'Your seat selection is invalid. You must select seats from the end of a row. Please choose a different placement.',
    seat_taken: 'Seats shown in red are taken.',
    seat_selection_required: 'Please select seats for {event}.',
    event_seatmap_progress: 'Event {current} of {total}',
    next_event_seats: 'Select seats for {event}',
    switching_to_event: 'Now select seats for: {event}',
    seats_remaining_one: 'You still need to select 1 ticket',
    seats_remaining: 'You still need to select {count} tickets',
    extra_tickets_shown:
      '{count} additional tickets are now shown with the code:',
    extra_ticket_shown: '1 additional ticket is now shown with the code:',
    tickets_recievement_notice:
      'You will receive your ticket by e-mail and must bring it digitally or print it yourself.',
    thanks_for_your_order: 'Thank you for your order',
    ticket_buying_title: 'Ticket purchase info',
    ticket_buying_notice: 'Your tickets are paid. You can download them here.',
    tickets_sent_to_email:
      'We have also sent your tickets to your e-mail address: {email}',
    tickets_entry_notice:
      'The organizer may ask you to show your ticket at the entrance. Please check the ticket for event, date, time, etc. It is important that your ticket is intact and legible when you arrive at the event. A ticket and the unique barcode admit one person. It is illegal to copy tickets.',
    tickets_bank_statement:
      'The ticket purchase will appear as a purchase from Safeticket on your bank statement.',
    tickets_law_notice:
      'Note: According to the "Consumer Contracts Act § 18 section 12", ticket purchases are not subject to the right of withdrawal.',
    tickets_see_terms: 'See also the ',
    tickets_see_terms_link: 'terms and conditions.',
    questions: 'Questions?',
    questions_can_be_sent_to:
      'Questions can be sent to <a href="mailto:{email}">{email}</a> or <a href="tel:{phone}">{phone}</a>.',
    questions_order_number:
      'Please provide your order number when contacting Safeticket A/S.',
    customfield_group_header_event: '',
    customfield_group_header_tickettype: 'General for registration',
    customfield_group_header_ticket: '{group} Registration',
    invoice_payment: 'Invoice payment',
    card_payment: 'Card payment',
    ivp_name_placeholder: 'Company / Institution',
    ivp_attperson_placeholder: 'Att. person',
    ivp_address_placeholder: 'Address',
    ivp_zip_placeholder: 'Postal code',
    ivp_city_placeholder: 'City',
    ivp_email_placeholder: 'E-mail',
    ivp_repeat_email_placeholder: 'Repeat e-mail',
    ivp_ean_placeholder: 'EAN number',
    ivp_cvr_placeholder: 'CVR number',
    ivp_reference_placeholder: 'Reference',
    ivp_terms_label:
      'I accept that the tickets are non-refundable, and that I will receive an invoice afterwards.',
    ivp_submit: 'Proceed to payment',
    limit_order_by_userdefined_id_buy_limit:
      'Your reservation has been adjusted to the maximum allowed for this ticket.',
    limit_order_by_userdefined_id_invalid:
      'The provided customer ID is not valid. If this continues, contact the organizer.',
    limit_order_by_userdefined_id_no_response:
      'Reservation could not be completed due to lack of response from the organizer.',
    event_state: {
      loading: 'Loading ticket sale...',
      not_started: {
        title: 'Ticket sale has not started yet',
        description: 'Ticket sales for this event will open later.',
        description_with_date: 'Ticket sales open {date}.',
      },
      ended: {
        title: 'Ticket sale has ended',
        description: 'Tickets for this event are no longer available for purchase.',
      },
      sold_out: {
        title: 'This event is sold out',
        description: 'There are no more tickets available for this event.',
      },
      not_found: {
        title: 'Event not found',
        description: 'The link may be incorrect, or the event is no longer available.',
      },
      error: {
        title: 'Something went wrong',
        description: 'The ticket sale could not be loaded. Close this window and try again.',
      },
    },
    sale_is_over: 'Ticket sale for this event has ended.',
  },
  event: {
    events: 'Events',
    play_video: 'Play video',
    go_to_slide: 'Go to slide {slide}',
    open_in_google_maps: 'Open in Google Maps',
    location: 'Location',
    find_tickets: 'Find tickets',
    login_to_find_tickets: 'Log in to view tickets',
    sso_no_access: 'You must be a subscriber to buy tickets',
    x_tickets_left: '{count} tickets left',
    time: 'Time',
    related_events: 'Related events',
    categories: 'Categories',
    organizer: 'Organizer',
    organizer_name: 'Organizer name',
    remarks: 'Remarks',
    photo_video_social_media: 'Photo, video and social media',
    photo_video: 'Photo and Video',
    photo_video_notice:
      'Ut ultricies vestibulum lacus in semper consectetur. Donec non tellus ut enim aliquet lacinia. Aenean ac orci id elit molestudas rhoncus porttitor eget lacus. Quisque a justo tristique, congue dolor et, scelerisque velit. Mauris eget dictum pulvinar. Sed bibendum ut magna ut tincidunt. Praesent pretium ut mi elementum. Phasellus condimentum leo quis erat rhoncus, et lacinia mi dictum.',
    social_media: 'Social media',
    social_media_notice:
      'Ut ultricies vestibulum lacus in semper consectetur. Donec non tellus ut enim aliquet lacinia. Aenean ac orci id elit molestudas rhoncus porttitor eget lacus. Quisque a justo tristique, congue dolor et, scelerisque velit. Mauris eget dictum pulvinar. Sed bibendum ut magna ut tincidunt. Praesent pretium ut mi elementum. Phasellus condimentum leo quis erat rhoncus, et lacinia mi dictum.',
    ends_in: 'Ends in',
    ends_at: 'Ends',
    starts_in: 'Starts in',
    sold_out: 'Sold out',
    subscribe_to_waitlist: 'Subscribe to waitlist',
    waitlist_modal_title: 'Subscribe to waitlist',
    waitlist_description:
      'Enter your email address to be added to the waitlist. You will receive a notification when tickets become available.',
    waitlist_success: 'You have been added to the waitlist',
    waitlist_error_invalid_email: 'Please enter a valid email address',
    waitlist_error_generic: 'An error occurred. Please try again.',
    sale_not_started: 'Ticket sale not started yet',
    sale_not_started_with_date: 'Ticket sale starts {date}',
    sale_ended: 'Sale ended',
    doorsale_button: 'Sold at the entrance',
    visit_external_shop: 'Visit webshop',
  },
  validation: {
    number: 'This field must be a number',
    email: 'Please enter a valid e-mail address',
    emails_must_match: 'E-mail addresses must match',
    phone: 'Please enter a valid phone number',
    cpr: 'Please enter a valid CPR number',
    required: 'This field is required',
    zip: 'Please enter a valid postal code',
    terms: 'You must accept the terms and conditions',
    terms_generic: 'You must accept the terms',
    order_number: 'Please enter a valid order number',
    char_limit: 'Maximum {limit} characters allowed',
    exact_length: 'This field must be exactly {length} characters',
    invalid_option: 'Please enter a valid value',
  },
  order_errors: {
    missingemail: 'Please enter your email address',
    invalidemail: 'The email address entered is invalid',
    missingname: 'Please enter your name',
    missingaddress: 'Please enter your address',
    missingzip: 'Please enter your postal code',
    missingcity: 'Please enter your city',
    missingtelephone: 'Please enter your phone number',
    missingcountry: 'Please select a country',
    unknown: 'An error occurred. Please try again.',
    invalid_custom_fields:
      'One or more fields contain invalid values. Please review and correct the highlighted fields.',
  },
  globals: {
    change_language: 'Change Language',
    categories: 'Categories',
    locations: 'Locations',
    date: 'Date',
    search: 'Search',
    search_placeholder: 'Search for events...',
    cart: 'Cart',
    continue_to_checkout: 'Continue to checkout',
    login: 'Login',
    sso_login: 'Log in',
    sso_logout: 'Log out',
    sso_welcome: 'Welcome',
    cart_empty: 'Your cart is empty',
    check_gift_card: 'Check gift card',
    cancel_tickets: 'Cancel tickets',
    transfer_voucher: 'Transfer voucher',
    organizer_login: 'Organizer login',
    ticketing_system: 'Ticketing system',
    registration_system: 'Registration system',
    ticket_buyer: 'Ticket buyer',
    resend_tickets: 'Lost your ticket?',
    contact: 'Contact',
    terms: 'Terms',
    cookies: 'Cookies',
    cta_title: 'Hosting events? Get a ticketing and registration system',
    cta_unique_selling_point_low_fee: 'Among the lowest fees in Denmark',
    cta_unique_selling_point_support: 'Free Danish support',
    cta_button_text: 'Learn more',
    choose: 'Choose',
    no_results: 'No results. Try again.',
    see_all_events: 'See all events',
    special_categories: 'Special categories',
    cookie_warning_dismiss: 'OK - Close!',
    cookie_warning_read_more: 'Read more',
    cookie_warning_header: 'Cookies',
    consent_accept_all: 'Accept all',
    consent_reject_all: 'Reject all',
    consent_customize: 'Customize',
    consent_save_preferences: 'Save preferences',
    consent_necessary_title: 'Necessary',
    consent_necessary_description:
      'These cookies are required for the site to function properly.',
    consent_statistics_title: 'Statistics',
    consent_statistics_description:
      'Help us understand how visitors use the site.',
    consent_marketing_title: 'Marketing',
    consent_marketing_description:
      'Used to show relevant ads on other platforms.',
    consent_footer_link: 'Cookie settings',
  },
  date: {
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
    sun: 'Sun',
  },
  not_found: {
    title: 'Page Not Found',
    message: 'Sorry, the page you are looking for does not exist.',
    back_to_home: 'Back to home',
  },
  terms: {
    head_title: 'Terms',
    organizer: 'Organizer',
    sales_delivery_terms: 'Sales and delivery terms',
    contact_person: 'Contact person',
    phone: 'Phone',
    email: 'E-mail',
    vat: 'CVR',
    applicable_for: 'The following terms apply to',
    hereafter_referred: 'Hereinafter referred to as',
    general: 'GENERAL',
    general_clause_1:
      'Any delivery between the parties is based on these general sales and delivery terms.',
    general_clause_2:
      'exclusively mediates the sale of tickets between the ticket buyer and the responsible organizer.',
    payment: 'PAYMENT',
    payment_clause_1:
      'Payment can be made with Dankort, Visa/Dankort, Visa, MasterCard, and VisaElectron.',
    payment_clause_2: 'Payment must be made by online payment.',
    payment_clause_3:
      'Your payment is charged to your payment card when the ticket is dispatched.',
    delivery: 'DELIVERY AND DELAY',
    delivery_clause_1:
      'Delivery is either via direct download and e-mail in the form of a PDF file (PrintSelv) immediately after payment, or by choosing postal delivery, sent with PostDanmark as regular mail the next business day. The money is charged to your payment card when the ticket is dispatched.',
    delivery_clause_2:
      'In case of loss, replacement tickets can be sent, whereby the original tickets are automatically canceled.',
    privacy: 'PROCESSING OF PERSONAL DATA',
    privacy_clause_1:
      'As a customer, you accept that {name} stores the personal data you provide in connection with ticket purchases.',
    privacy_clause_2:
      '{name} transfers information such as name, address, phone number, and e-mail to the organizer responsible for the event for which you have purchased a ticket.',
    privacy_clause_3:
      'This is done to enable the organizer to provide optimal customer service, e.g., in case of cancellations.',
    privacy_clause_4:
      '{name} does not disclose the information to anyone other than the organizer of the specific event.',
    liability: 'LIMITATION OF LIABILITY',
    liability_clause_1:
      'Please check the order before payment to avoid errors.',
    liability_clause_2:
      'The ticket is not replaced in case of loss but can be resent electronically or by mail.',
    liability_clause_3:
      'The ticket can ONLY be refunded by the organizer and ONLY in case of cancellation.',
    liability_clause_4: 'Booking and delivery fees are non-refundable.',
    liability_clause_5:
      "{name} has no liability regarding the 's possible payment default, bankruptcy, cancellation, or rescheduling of the event date or other complaints regarding the current event.",
    liability_clause_6:
      'All inquiries in this regard should be directed to the organizer. Contact information can be found on the ticket and the website where the ticket was ordered.',
    liability_clause_7:
      'VAT is 20% of the ticket price including the ticket fee, if VAT is applicable to the event.',
    refund: 'RIGHT OF WITHDRAWAL',
    refund_clause_1:
      "{name} only acts as an intermediary for the sale of tickets between the customer and the organizer selling the tickets via {name}'s online systems.",
    refund_clause_2:
      'Note: According to the "Consumer Contracts Act § 18 section 12", ticket purchases are not subject to the right of withdrawal.',
    changes: 'AMENDMENTS',
    changes_clause_1:
      "{name} has the right, at any time, to make changes to the applicable business terms or prices with 30 days' notice.",
    law: 'GOVERNING LAW AND JURISDICTION',
    law_clause_1:
      'The agreement is governed by Danish law. Any dispute between the parties is settled by the Court in Aarhus.',
  },
  contact: {
    head_title: 'Contact',
    email_placeholder: 'E-mail',
    name_placeholder: 'First and last name',
    phone_placeholder: 'Phone number',
    order_number_placeholder: 'Order number',
    body_placeholder: 'Message',
    title: 'Contact us',
    info: 'Info',
    description:
      "If you have questions about events listed on these pages under {url}, you can contact the organizer's contact person at the phone number or email address below.",
    organizer: 'Organizer',
    contact_person: 'Contact person',
    phone: 'Phone',
    email: 'E-mail',
    contact_form_info:
      'You can also contact the organizer via the contact form below.',
    contact_form: 'Contact form',
    submit: 'Submit',
    success_message: 'Your message has been sent!',
    error_message:
      'There was an error submitting your message. Please try again later.',
  },
  doorsale: {
    select_events: 'Select events',
    search_placeholder: 'Search...',
    loading: 'Loading events...',
    loading_receipt: 'Loading receipt...',
    fetch_error: 'An error occurred while loading events.',
    no_results: 'No results',
    reset_filters: 'Reset filters',
    no_events: 'No events available',
    selected_events_one: 'selected event',
    selected_events_other: 'selected events',
    show_list: 'Show',
    hide_list: 'Hide',
    remove_all: 'Remove all',
    remove_event: 'Remove',
    remove_event_cart_title: 'Removing an event will reset the entire basket.',
    remove_event_cart_confirm: 'OK, reset the basket',
    remove_event_cart_cancel: 'Close - keep my basket',
    no_events_selected: 'No events selected',
    continue: 'Continue',
    confirm_payment: 'Confirm payment',
    placing_order: 'Processing...',
    progress_bar: 'Event {n} of {total}',
    header_step_tickets: 'Tickets',
    header_step_customer_info: 'Customer info',
    header_step_receipt: 'Receipt',
    receipt_title: 'Sale completed',
    receipt_order_details: 'Order details',
    mark_arrived: 'Mark as arrived',
    mark_arrived_loading: 'Marking...',
    mark_arrived_success: 'Arrived',
    mark_arrived_error: 'Error – try again',
    print_tickets: 'Print tickets',
    new_sale: 'New sale',
    mark_arrived_question: 'Is the guest/guests arrived?',
    mark_arrived_yes: 'Yes',
    mark_arrived_no: 'No',
    fetch_tickets: 'Get tickets',
    print_receipt: 'Print receipt',
    order_email: 'Participant email',
    print_buyer: 'Buyer',
    print_items: 'Tickets',
    print_financial_summary: 'Payment summary',
    print_subtotal: 'Subtotal',
    print_card_fee: 'Card fee',
    print_dankort_discount: 'Dankort discount',
    order_confirmation_will_be_sent_to:
      'The order confirmation will be sent here',
    banner_mode: 'You are in "issue tickets" mode',
    banner_close: 'Close',
  },
  selfscan: {
    head_title: 'Ticket activation',
    title: 'Activate your tickets',
    description: 'Select the ticket you want to activate when you arrive at the event.',
    loading: 'Loading tickets...',
    invalid_link_title: 'This link is invalid',
    invalid_link_description: 'Check that you opened the complete link from your ticket email.',
    not_found_title: 'Tickets not found',
    not_found_description: 'The link may be incorrect, or ticket activation is not available for this order.',
    no_tickets: 'There are no tickets available for activation on this order.',
    opens_at: 'Available for activation from {date}',
    event: 'Event',
    event_time: 'Time',
    ticket_type: 'Ticket type',
    ticket_number: 'Ticket number',
    activation_time: 'Activated',
    status: 'Status',
    activate: 'Activate',
    activated: 'Activated',
    activated_at: 'Activated {date}',
    confirm_eyebrow: 'Ticket activation',
    confirm_title: 'Activate ticket',
    confirm_description: 'Check that you are ready to use the ticket.',
    warning_title: 'Important before activation',
    warning_description: 'Only activate on presentation',
    swipe_instruction: 'Swipe to activate',
    swipe_accessible_label: 'Swipe right to activate the ticket',
    swipe_progress: '{progress} percent activated',
    swipe_keyboard_instruction: 'Use Enter or Space to activate with the keyboard.',
    activating: 'Activating...',
    activation_error: 'The ticket could not be activated. Try again.',
    success_title: 'Already activated',
    countdown_description: 'Ticket information will be shown automatically in',
    countdown_seconds: '{count} seconds remaining',
    ticket_info_title: 'Ticket information',
    ticket_info_description: 'This ticket has already been activated.',
    back_to_tickets: 'Back to tickets',
  },
  resend_ticket: {
    head_title: 'Resend tickets',
    title: 'Resend your tickets',
    description:
      'Did you not receive your tickets? Enter your email address below and we will resend them.',
    email_placeholder: 'E-mail',
    submit: 'Resend tickets',
    success_message: 'Your tickets have been sent to your email address.',
    error_too_soon:
      'You have already requested your tickets to be resent recently. Please wait a moment and try again.',
    error_invalid_email:
      'We could not find any orders associated with this email address.',
    error_generic: 'An error occurred. Please try again later.',
  },
  toggle: {
    yes: 'Yes',
    no: 'No',
  },
  cancel_order: {
    head_title: 'Cancel tickets',
    title: 'Cancel tickets',
    description:
      'Enter your email and an order number to cancel your tickets. You will receive an email where you need to confirm the cancellation.',
    email_placeholder: 'E-mail',
    order_id_placeholder: 'Order number',
    submit: 'Send',
    success_message:
      'We have sent a confirmation email to your email address. Follow the link in the email to complete the cancellation.',
    error_order_not_found:
      'We could not find an order with the provided order number and email address.',
    error_invalid_email: 'The email address entered is invalid.',
    error_invalid_order_id: 'The order number must be a valid number.',
    error_price_above_zero:
      'This order cannot be cancelled online as it has a price above 0. Please contact the organizer.',
    error_already_cancelled: 'This order has already been cancelled.',
    error_already_refunded: 'This order has already been refunded.',
    error_generic: 'An error occurred. Please try again later.',
  },
  check_giftcard: {
    head_title: 'Check gift card',
    title: 'Check gift card',
    description:
      'Enter your gift card code below to view balance and transaction history.',
    code_placeholder: 'Gift card code',
    submit: 'Check balance',
    error_not_found:
      'Gift card not found. Please check the code and try again.',
    error_generic: 'An error occurred. Please try again later.',
    result_code: 'Code',
    result_issue_date: 'Issued',
    result_expire_date: 'Expires',
    result_balance: 'Balance',
    transaction_header_date: 'Date',
    transaction_header_type: 'Action',
    transaction_header_amount: 'Amount',
    transaction_type_deposit: 'Deposited',
    transaction_type_withdraw: 'Withdrawn',
  },
  meta: {
    frontpage_title: "See upcoming events {'|'} {alias}",
    frontpage_description: 'See all upcoming events at {alias}',
  },
};

export const messages = {
  en,
  da,
};
